export enum ProductLineItemType {
  NORMAL = 'normal',
  GROUP = 'group',
}
